import { ADD_REMOVED_IMAGE, ADD_ADDED_IMAGE, RESET_IMAGE_DATA } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    removedImages: [],
    addedImages: [],
  },

  mutations: {
    [RESET_IMAGE_DATA](state) {
      state.removedImages = []
      state.addedImages = []
    },
    [ADD_REMOVED_IMAGE](state, payload) {
      // First we remove the image from the list of added images (if found)
      state.addedImages = state.addedImages.filter((addedImage) => addedImage !== payload)
      state.removedImages.push(payload)
    },
    [ADD_ADDED_IMAGE](state, payload) {
      state.addedImages.push(payload)
    },
  },
  actions: {
    resetImageData({ commit }) {
      commit(RESET_IMAGE_DATA)
    },
    addAddedImage({ commit }, payload) {
      commit(ADD_ADDED_IMAGE, payload)
    },
    addRemovedImage({ commit }, payload) {
      commit(ADD_REMOVED_IMAGE, payload)
    },
  },
  getters: {
    addedImages(state) {
      return state.addedImages
    },
    removedImages(state) {
      return state.removedImages
    },
  },
}
